import { getBFFApiClient } from '@acp/feature/auth';
import { APIResponse, ActiveIntegration } from '@acp/shared';
import HttpStatusCodes from 'http-status-codes';

async function getActiveIntegrations() {
    const response = await getBFFApiClient().get<APIResponse<ActiveIntegration[]>>('/v1/agency/integration');

    if (response.status !== HttpStatusCodes.OK || !response.data.success) {
        throw new Error(`Failed to get integrations: ${response.data.error}`);
    }

    return response.data.data;
}

export { getActiveIntegrations };
